
export const GET_ACTIVE_ORDERS_OF_VENUE= 'GET_ACTIVE_ORDERS_OF_VENUE'
export const GET_ACTIVE_ORDERS_OF_VENUE_SUCCESS= 'GET_ACTIVE_ORDERS_OF_VENUE_SUCCESS'
export const GET_ACTIVE_ORDERS_OF_VENUE_ERROR='GET_ACTIVE_ORDERS_OF_VENUE_ERROR'


export const GetActiveOrdersOfVenue= (data) => ({
    type: GET_ACTIVE_ORDERS_OF_VENUE,
    payload: data
});
